import api from '@/services/api/config';

const path = 'v1/prozesskontrollkarte/stoppgrund';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: () => api.get(path),
};
